import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import useRestrictedReportsHook from "../hooks/RestrictedReportsHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";

const RestrictedCourseRosterFall = ({ schoolId, linkColor }) => {
  const { data, loading } = useRestrictedReportsHook(schoolId);

  const restricted_course_roster_fall =
    data.length > 0 ? data[0].restricted_course_roster_fall : "";

  if (loading) {
    return <div>Loading...</div>;
  }
  const subject = "Restricted Course Roster Fall";

  return (
    <Card>
      <CardHeader
        title="Restricted Course Roster Fall"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {restricted_course_roster_fall && (
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <Button
              variant="contained"
              component="a"
              href={restricted_course_roster_fall}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#AC1A2F",
                color: "white",
                minWidth: "auto",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#8B0000",
                },
              }}
            >
              View Report
            </Button>
            <SchoolNotificationButton subject={subject} schoolId={schoolId} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default RestrictedCourseRosterFall;
